import type { RiskFlowAlert } from "./riskflow-feed";
import { riskFlowNotificationMetadata } from "./riskflow-notification-metadata";

export const RISKFLOW_HEADLINE_NOTIFICATION_FLOOR = 6.5;

export function shouldNotifyRiskFlowHeadline(
  alert: Pick<RiskFlowAlert, "ivScore">,
): boolean {
  return (
    typeof alert.ivScore === "number" &&
    Number.isFinite(alert.ivScore) &&
    alert.ivScore >= RISKFLOW_HEADLINE_NOTIFICATION_FLOOR
  );
}

export function shouldDeliverRiskFlowHeadlineCard(
  alert: Pick<RiskFlowAlert, "ivScore">,
  isTradingSurfaceActive: boolean,
): boolean {
  return isTradingSurfaceActive && shouldNotifyRiskFlowHeadline(alert);
}

export function riskFlowHeadlineNotificationDetail(
  alert: RiskFlowAlert,
  watchPhrase?: string,
) {
  return {
    id: `riskflow-headline-${alert.id}`,
    eventId: alert.id,
    category: "riskflow",
    severity: alert.severity,
    title: watchPhrase ? `WatchTag: ${watchPhrase}` : "Fintheon · RiskFlow",
    message: alert.headline,
    timestamp: new Date(alert.publishedAt),
    url: alert.url,
    ivScore: alert.ivScore,
    riskType: alert.riskType,
    source: alert.source,
    imageUrl: alert.imageUrl,
    videoUrl: alert.videoUrl,
    metadata: riskFlowNotificationMetadata(alert),
  };
}
